module.exports = __webpack_public_path__ + "media/agora-incoming-call.49106cb6.wav";